import View from "backdraft-app/src/view";
import { initListeners } from "../helpers/listeners";
import { renderIntegrationStep } from "../helpers/renderers";
import _ from "underscore";

class IntegrationStep extends View {
  constructor(options) {
    super();

    this.app = options.app;
    this.model = options.model;
    initListeners(this);
  }

  render() {
    renderIntegrationStep(this.app, this);
  }

  _handleNextButtonClick() {
    throw new Error("_handleNextButtonClick must be implemented by a subclass");
  }
}

class FirstStep extends IntegrationStep { }

class IntermediateStep extends IntegrationStep {
  _handleBackButtonClick() {
    throw new Error("_handleBackButtonClick must be implemented by a subclass");
  }
}

_.extend(FirstStep.prototype, {
  events: {
    "click #next-integration-button": "_handleNextButtonClick"
  }
});

_.extend(IntermediateStep.prototype, {
  events: {
    "click #next-step-button": "_handleNextButtonClick",
    "click #back-step-button": "_handleBackButtonClick"
  }
});

export { IntegrationStep, FirstStep, IntermediateStep };
